'use strict';

var makeNonNullableArray = require('./makeNonNullableArray.js');

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/**
 * Merges the given props and className into a new object.
 *
 * @template T - The type of the props object.
 * @param {T} props - The props object to merge.
 * @param {string} className - The className to merge.
 * @returns {T & { className: string }} - The merged props object with the merged className.
 */ function mergePropsClassName(props, className) {
    return _extends({}, props, {
        className: makeNonNullableArray([
            props == null ? void 0 : props.className,
            className
        ]).join(' ')
    });
}

module.exports = mergePropsClassName;
